module.exports = __webpack_public_path__ + "img/28_32.ab0fa785.png";